import { roundRating } from '../../../../domain';
import descriptionTextSvg from './description_text.svg';
import ratingValueTextSvg from './rating_value_text.svg';
import './PlaqueContent.css';

type PlaqueContentProps = {
  averageRating?: number;
};

/** description_text (154:32584) + rating_value_text (154:32585) — SVG exports. */
export function PlaqueContent({ averageRating }: PlaqueContentProps) {
  const ratingLabel =
    averageRating != null && Number.isFinite(averageRating)
      ? roundRating(averageRating).toFixed(1)
      : null;

  return (
    <>
      <img
        className="rating-plaque__description"
        src={descriptionTextSvg}
        alt="Средний рейтинг доставок"
        draggable={false}
      />
      {ratingLabel != null ? (
        <span className="rating-plaque__value rating-plaque__value--live" aria-live="polite">
          {ratingLabel}
        </span>
      ) : (
        <img
          className="rating-plaque__value"
          src={ratingValueTextSvg}
          alt=""
          draggable={false}
          aria-hidden
        />
      )}
    </>
  );
}
